<div class="col-12-nav">
    <div class="signin-header">
        <div class="container">
            <section class="logo center-block-wrap">
                <div class="logo-white"></div>
            </section>
        </div>
    </div>
    <div class="img-background">
        <ngx-spinner bdColor="rgba(51,51,51,0.55)"
            size="medium"
            color="#fff"
            type="line-spin-clockwise-fade"
            [fullScreen]="false">
            <p class="loading">{{ 'general.loading' | translate }}...</p>
        </ngx-spinner>
        <div class="d-flex flex-row bd-highlight mt-2">
            <div class="bd-highlight justify-content-start flex-grow-1">
                <h2 class="page-title pl-3 mt-0">{{ 'recorded_video_call' | translate }}</h2>
            </div>
            <div class="bd-highlight justify-content-end align-self-center">
                <a tabindex="0" id="en" class="btn btn-default border border-left-0 border-top-0 border-bottom-0 border-dark rounded-0" (click)="functionsService.useLanguage('en')">EN <span class="sr-only">Change language to English</span></a>
                <a tabindex="0" id="es" class="btn btn-default" (click)="functionsService.useLanguage('es')">ES <span class="sr-only">Cambiar idioma a español</span></a>
            </div>
        </div>


        <div class="row">
            <div class="col-12 text-center mt-3">
                <video [src]="mediaLink" controls disablePictureInPicture></video>
            </div>
        </div>
    </div>
</div>
